var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVpagLogoMinimal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5094 14.2015L37.6321 39.9094C36.8846 40.6522 35.9971 41.2415 35.0204 41.6435C34.0436 42.0455 32.9966 42.2525 31.9393 42.2525C30.882 42.2525 29.835 42.0455 28.8582 41.6435C27.8815 41.2415 26.994 40.6522 26.2465 39.9094L0.365405 14.2015C0.131423 13.9688 0 13.6533 0 13.3243C0 12.9954 0.131423 12.6799 0.365405 12.4471L12.5285 0.36457C12.6442 0.249024 12.7819 0.157335 12.9334 0.0947711C13.0849 0.032207 13.2474 0 13.4115 0C13.5756 0 13.7381 0.032207 13.8897 0.0947711C14.0412 0.157335 14.1788 0.249024 14.2946 0.36457L38.7244 24.6326C42.798 28.6792 49.7626 25.8131 49.7626 20.0921V0.858475C49.7622 0.688846 49.8125 0.522926 49.9072 0.381762C50.0019 0.240598 50.1366 0.130553 50.2944 0.0655864C50.4521 0.00062018 50.6257 -0.0163391 50.7932 0.0168601C50.9606 0.0500592 51.1144 0.131921 51.2349 0.252059L63.5094 12.4567C63.7404 12.689 63.87 13.0025 63.87 13.3291C63.87 13.6557 63.7404 13.9692 63.5094 14.2015Z",
    fill: "#BFF736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpagLogoMinimal);
export default __webpack_public_path__ + "static/media/vpagLogoMinimal.b13392b70f196a9b6c8414291f9e33b0.svg";
export { ForwardRef as ReactComponent };